module.exports = __webpack_public_path__ + "img/s-class-maybach.cb8d0c8c.jpg";